export default "__VITE_ASSET__CznUaE_y__"